import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerInterface } from '@contracts/interfaces/customer.interface';
import { Task, TaskStatus } from '@contracts/interfaces/task.interface';
import { CustomerDialogService } from '../customer/customer.service.dialog';
import { TaskService } from '../../services/task.service';
import { CustomerSearchDialogComponent } from '../customer-search/customer-search.dialog';

@Component({
  selector: 'task-create-dialog',
  templateUrl: 'task-create.dialog.html',
  styleUrls: ['./task-create.dialog.scss']
})
export class TaskCreateDialog {

  newTask: Task = {
    id: 0,
    date: new Date(),
    type: '',
    status: TaskStatus.InProgress,
    customer: null,
    subject: '',
    description: '',
    dueDate: '',
    log: [],
    quote: 0
  };

  isSaving = false;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<TaskCreateDialog>,
      public dialog: MatDialog,
      private taskService: TaskService,
      private customerDialogService: CustomerDialogService
      ) {
        
      }

  createTask() {
    if (this.isSaving || !this.canCreateTask()) {
      return;
    }

    this.isSaving = true;
    this.taskService.create(this.newTask).subscribe({
      next: (r: any) => {
        this.isSaving = false;
        this.dialogRef.close(r);
      },
      error: () => {
        this.isSaving = false;
      }
    });
  }

  openCustomerSearch() {
    const dialogRef = this.dialog.open(CustomerSearchDialogComponent, {
      width: '640px',
      maxWidth: '95vw',
      position: {
        top: '20px'
      },
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe((customer?: CustomerInterface) => {
      if (customer?._id) {
        this.newTask.customer = customer;
      }
    });
  }

  chooseDifferentCustomer() {
    this.newTask.customer = null;
    this.openCustomerSearch();
  }

  editCustomer() {
    this.customerDialogService.launchDialog(this.newTask.customer, null, (r: any) => {
      if (r != '' && r != undefined) {
        this.newTask.customer = r;
      }
    });
  }

  hasCustomer() {
    return this.newTask.customer != null;
  }

  canCreateTask() {
    return this.hasCustomer()
      && !!this.newTask.subject?.trim()
      && !!this.newTask.description?.trim();
  }
}
